export default __webpack_public_path__ + "static/media/factor_item_1.2cd104e9.png";